import apiClient from '../helper/apiClient';
import { SERVICE_ROUTES } from '../constants/service.constants';

export const fetchPatientAbridgeConsent = async payload => {
  const httpClient = apiClient.getZoomAppBffInstance();
  return httpClient.post(SERVICE_ROUTES.FETCH_PATIENT_ABRIDGE_CONSENT, payload);
};
